import Header from '../packages/header';
import Button from '../packages/button';
import ButtonList from '../packages/button-list';
import CommandBar from '../packages/command-bar';
import CellGroup from '../packages/cell-group';
import Cell from '../packages/cell';
import CellSwipe from '../packages/cell-swipe';
import Field from '../packages/field';
import FileList from '../packages/file-list';
import Badge from '../packages/badge';
import Step from '../packages/step';
import Steps from '../packages/steps';
import Switch from '../packages/switch';
import Switcher from '../packages/switcher';
import Spinner from '../packages/spinner';
import TabItem from '../packages/tab-item';
import TabContainerItem from '../packages/tab-container-item';
import TabContainer from '../packages/tab-container';
import Navbar from '../packages/navbar';
import SideNavbar from '../packages/side-navbar';
import Tabbar from '../packages/tabbar';
import Search from '../packages/search';
import Checkbox from '../packages/checkbox';
import Radiobox from '../packages/radiobox';
import BoxGroup from '../packages/box-group';
import Loadmore from '../packages/loadmore';
import Actionsheet from '../packages/actionsheet';
import Popup from '../packages/popup';
import Swipe from '../packages/swipe';
import SwipeItem from '../packages/swipe-item';
import Range from '../packages/range';
import Picker from '../packages/picker';
import Select from '../packages/select';
import TextSelect from '../packages/text-select';
import PickerSelect from '../packages/picker-select';
import DatetimeSelector from '../packages/datetime-selector';
import Calendar from '../packages/calendar';
import TreeSelector from '../packages/tree-selector';
import Progress from '../packages/progress';
import Toast from '../packages/toast';
import Indicator from '../packages/indicator';
import MessageBox from '../packages/message-box';
import InfiniteScroll from '../packages/infinite-scroll';
import Lazyload from '../packages/lazyload';
import DatetimePicker from '../packages/datetime-picker';
import IndexList from '../packages/index-list';
import IndexSection from '../packages/index-section';
import PaletteButton from '../packages/palette-button';
import Textarea from '../packages/textarea';
import Text from '../packages/text';
import Image from '../packages/image';
import ImageClip from '../packages/image-clip';
import ImagePreview from '../packages/image-preview';
import FixedButton from '../packages/fixed-button';
import LayoutLeftRight from '../packages/layout-left-right';
import LayoutLeftRightItem from '../packages/layout-left-right-item';
import LayoutContainer from '../packages/layout-container';
import LayoutContainerStatus from '../packages/layout-container-status';
import FixedContainer from '../packages/fixed-container';
import LayoutContainerMultiple from '../packages/layout-container-multiple';
import LayoutContainerMultipleItem from '../packages/layout-container-multiple-item';
import DirectiveFor from '../packages/directive-for';
import DirectiveIf from '../packages/directive-if';
import DirectiveElse from '../packages/directive-else';
import DirectiveElseIf from '../packages/directive-else-if';
import DirectiveShow from '../packages/directive-show';
import Hr from '../packages/hr';
import Icon from '../packages/icon';
import LayoutSpacing from '../packages/layout-spacing';
import Form from '../packages/form';
import ValidateRules from '../packages/validate-rules';
import DropdownMenus from '../packages/dropdown-menus';
import Subscript from '../packages/subscript';
import '../src/style/reset.css';
import merge from './utils/merge';

// 兼容部分低版本手机 Object.assign 为undefined;(vivo android 5.1.1) 使用组件：日历组件  报告人：王永建 2018/11/1
if (typeof Object.assign !== 'function') {
// Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, 'assign', {
    value: function assign(target, varArgs) { // .length of function is 2
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

const version = '1.1.44';
const install = function(Vue, config = {}) {
  if (install.installed) return;
  Vue.component(Header.name, Header);
  Vue.component(Button.name, Button);
  Vue.component(ButtonList.name, ButtonList);
  Vue.component(CommandBar.name, CommandBar);
  Vue.component(CellGroup.name, CellGroup);
  Vue.component(Cell.name, Cell);
  Vue.component(CellSwipe.name, CellSwipe);
  Vue.component(Field.name, Field);
  Vue.component(FileList.name, FileList);
  Vue.component(Badge.name, Badge);
  Vue.component(Step.name, Step);
  Vue.component(Steps.name, Steps);
  Vue.component(Switch.name, Switch);
  Vue.component(Switcher.name, Switcher);
  Vue.component(Spinner.name, Spinner);
  Vue.component(TabItem.name, TabItem);
  Vue.component(TabContainerItem.name, TabContainerItem);
  Vue.component(TabContainer.name, TabContainer);
  Vue.component(Navbar.name, Navbar);
  Vue.component(SideNavbar.name, SideNavbar);
  Vue.component(Tabbar.name, Tabbar);
  Vue.component(Search.name, Search);
  Vue.component(Checkbox.name, Checkbox);
  Vue.component(Radiobox.name, Radiobox);
  Vue.component(BoxGroup.name, BoxGroup);
  Vue.component(Loadmore.name, Loadmore);
  Vue.component(Actionsheet.name, Actionsheet);
  Vue.component(Popup.name, Popup);
  Vue.component(Swipe.name, Swipe);
  Vue.component(SwipeItem.name, SwipeItem);
  Vue.component(Range.name, Range);
  Vue.component(Picker.name, Picker);
  Vue.component(Select.name, Select);
  Vue.component(TextSelect.name, TextSelect);
  Vue.component(PickerSelect.name, PickerSelect);
  Vue.component(DatetimeSelector.name, DatetimeSelector);
  Vue.component(Calendar.name, Calendar);
  Vue.component(TreeSelector.name, TreeSelector);
  Vue.component(Progress.name, Progress);
  Vue.component(DatetimePicker.name, DatetimePicker);
  Vue.component(IndexList.name, IndexList);
  Vue.component(IndexSection.name, IndexSection);
  Vue.component(PaletteButton.name, PaletteButton);
  Vue.component(Textarea.name, Textarea);
  Vue.component(Text.name, Text);
  Vue.component(Image.name, Image);
  Vue.component(ImageClip.name, ImageClip);
  Vue.component(ImagePreview.name, ImagePreview);
  Vue.component(FixedButton.name, FixedButton);
  Vue.component(LayoutLeftRight.name, LayoutLeftRight);
  Vue.component(LayoutLeftRightItem.name, LayoutLeftRightItem);
  Vue.component(LayoutContainer.name, LayoutContainer);
  Vue.component(LayoutContainerStatus.name, LayoutContainerStatus);
  Vue.component(FixedContainer.name, FixedContainer);
  Vue.component(LayoutContainerMultiple.name, LayoutContainerMultiple);
  Vue.component(LayoutContainerMultipleItem.name, LayoutContainerMultipleItem);
  Vue.component(DirectiveFor.name, DirectiveFor);
  Vue.component(DirectiveIf.name, DirectiveIf);
  Vue.component(DirectiveElse.name, DirectiveElse);
  Vue.component(DirectiveElseIf.name, DirectiveElseIf);
  Vue.component(DirectiveShow.name, DirectiveShow);
  Vue.component(Hr.name, Hr);
  Vue.component(Icon.name, Icon);
  Vue.component(LayoutSpacing.name, LayoutSpacing);
  Vue.component(Form.name, Form);
  Vue.component(DropdownMenus.name, DropdownMenus);
  Vue.component(Subscript.name, Subscript);
  Vue.use(InfiniteScroll);
  Vue.use(Lazyload, merge({
    loading: require('./assets/loading-spin.svg'),
    attempt: 3
  }, config.lazyload));

  Vue.$messagebox = Vue.prototype.$messagebox = MessageBox;
  Vue.$toast = Vue.prototype.$toast = Toast;
  Vue.$indicator = Vue.prototype.$indicator = Indicator;
};
// auto install
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
};

window.MINT = {
  install,
  version,
    Header,
  Button,
  ButtonList,
  CommandBar,
  CellGroup,
  Cell,
  CellSwipe,
  Field,
  FileList,
  Badge,
  Step,
  Steps,
  Switch,
  Switcher,
  Spinner,
  TabItem,
  TabContainerItem,
  TabContainer,
  Navbar,
  SideNavbar,
  Tabbar,
  Search,
  Checkbox,
  Radiobox,
  BoxGroup,
  Loadmore,
  Actionsheet,
  Popup,
  Swipe,
  SwipeItem,
  Range,
  Picker,
  Select,
  TextSelect,
  PickerSelect,
  DatetimeSelector,
  Calendar,
  TreeSelector,
  Progress,
  Toast,
  Indicator,
  MessageBox,
  InfiniteScroll,
  Lazyload,
  DatetimePicker,
  IndexList,
  IndexSection,
  PaletteButton,
  Textarea,
  Text,
  Image,
  ImageClip,
  ImagePreview,
  FixedButton,
  LayoutLeftRight,
  LayoutLeftRightItem,
  LayoutContainer,
  LayoutContainerStatus,
  FixedContainer,
  LayoutContainerMultiple,
  LayoutContainerMultipleItem,
  DirectiveFor,
  DirectiveIf,
  DirectiveElse,
  DirectiveElseIf,
  DirectiveShow,
  Hr,
  Icon,
  LayoutSpacing,
  Form,
  ValidateRules,
  DropdownMenus,
  Subscript
};

export {
  install,
  version,
    Header,
  Button,
  ButtonList,
  CommandBar,
  CellGroup,
  Cell,
  CellSwipe,
  Field,
  FileList,
  Badge,
  Step,
  Steps,
  Switch,
  Switcher,
  Spinner,
  TabItem,
  TabContainerItem,
  TabContainer,
  Navbar,
  SideNavbar,
  Tabbar,
  Search,
  Checkbox,
  Radiobox,
  BoxGroup,
  Loadmore,
  Actionsheet,
  Popup,
  Swipe,
  SwipeItem,
  Range,
  Picker,
  Select,
  TextSelect,
  PickerSelect,
  DatetimeSelector,
  Calendar,
  TreeSelector,
  Progress,
  Toast,
  Indicator,
  MessageBox,
  InfiniteScroll,
  Lazyload,
  DatetimePicker,
  IndexList,
  IndexSection,
  PaletteButton,
  Textarea,
  Text,
  Image,
  ImageClip,
  ImagePreview,
  FixedButton,
  LayoutLeftRight,
  LayoutLeftRightItem,
  LayoutContainer,
  LayoutContainerStatus,
  FixedContainer,
  LayoutContainerMultiple,
  LayoutContainerMultipleItem,
  DirectiveFor,
  DirectiveIf,
  DirectiveElse,
  DirectiveElseIf,
  DirectiveShow,
  Hr,
  Icon,
  LayoutSpacing,
  Form,
  ValidateRules,
  DropdownMenus,
  Subscript
};
export default {
  install,
  version,
    Header,
  Button,
  ButtonList,
  CommandBar,
  CellGroup,
  Cell,
  CellSwipe,
  Field,
  FileList,
  Badge,
  Step,
  Steps,
  Switch,
  Switcher,
  Spinner,
  TabItem,
  TabContainerItem,
  TabContainer,
  Navbar,
  SideNavbar,
  Tabbar,
  Search,
  Checkbox,
  Radiobox,
  BoxGroup,
  Loadmore,
  Actionsheet,
  Popup,
  Swipe,
  SwipeItem,
  Range,
  Picker,
  Select,
  TextSelect,
  PickerSelect,
  DatetimeSelector,
  Calendar,
  TreeSelector,
  Progress,
  Toast,
  Indicator,
  MessageBox,
  InfiniteScroll,
  Lazyload,
  DatetimePicker,
  IndexList,
  IndexSection,
  PaletteButton,
  Textarea,
  Text,
  Image,
  ImageClip,
  ImagePreview,
  FixedButton,
  LayoutLeftRight,
  LayoutLeftRightItem,
  LayoutContainer,
  LayoutContainerStatus,
  FixedContainer,
  LayoutContainerMultiple,
  LayoutContainerMultipleItem,
  DirectiveFor,
  DirectiveIf,
  DirectiveElse,
  DirectiveElseIf,
  DirectiveShow,
  Hr,
  Icon,
  LayoutSpacing,
  Form,
  ValidateRules,
  DropdownMenus,
  Subscript
};



// WEBPACK FOOTER //
// ./src/index.js